import { render } from "./FormativeEval.vue?vue&type=template&id=25b140b3&scoped=true"
import script from "./FormativeEval.vue?vue&type=script&lang=js"
export * from "./FormativeEval.vue?vue&type=script&lang=js"

import "./FormativeEval.vue?vue&type=style&index=0&id=25b140b3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/demo-webapp/demo-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b140b3"]])

export default __exports__